import React, {forwardRef} from 'react';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import {ButtonProps} from "../../../../entity/props/widget/button-props";

import '../../../../assets/css/style.css';

export const Handle = forwardRef<HTMLButtonElement, ButtonProps>((props: ButtonProps, ref: React.ForwardedRef<HTMLButtonElement>): JSX.Element => {
  return (
      <button
          ref={ref}
          disabled={props.disabled}
          className={`handle-button ${props.disabled ? 'disabled' : ''}`}
          tabIndex={0}
          data-cypress="draggable-handle"
          {...props}>
          <DragIndicatorIcon fontSize='small' />
      </button>
  );
})
